import { render, staticRenderFns } from "./copyrightlist.vue?vue&type=template&id=72447710&"
import script from "./copyrightlist.vue?vue&type=script&lang=js&"
export * from "./copyrightlist.vue?vue&type=script&lang=js&"
import style0 from "./copyrightlist.vue?vue&type=style&index=0&id=72447710&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports